<template>
  <div>
    <div  v-if="loading">
      <skeleton-revenue />
    </div>
    <div class="vuse-content-wrapper mt-4" v-if="customers">
      <div>
          <v-row >
            <v-col>
              <h2 class="ml-3">
                {{$t(page+'.title')}}
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <ExcelIcon />
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="loadData">
                        <v-icon>sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
              </h2>
            </v-col>
            <v-spacer /> 
          </v-row>
          <template v-if="!customers && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5 mt-2">
              <v-col cols="12" class="ma-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                      v-if="customers"
                      dense
                      fixed-header="true"
                      :headers="i18_headers"
                      :items="customers"
                      :items-per-page="50"
                      :search="search"
                      multi-sort
                      class="elevation-1 mx-4"
                      :loading="loading" 
                      loading-text="Loading... Please wait"
                      primary-key="index"

                  >
                     <template #item.index="{ item }">
                        {{ customers.indexOf(item)+1 }}
                      </template>
                    <template v-slot:item.Authorized="{ item }">
                      <v-simple-checkbox color="primary" v-model="item.Authorized" disabled ></v-simple-checkbox>
                    </template>
                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-dialog v-model="msg_modal" max-width="850">
      <v-card class="overflow-hidden">
        <v-card-title class="text-h5"
          >Send a Message</v-card-title
        >
          <v-row  class="mt-5">
            <v-col cols="12" md="6">
              <v-img
                src="/static/ob-animated/setup-animate.svg"
                lazy-src="/static/ob-animated/setup-animate.svg"
                style="height:100%"
              ></v-img>
            </v-col>
            <v-col>
              <v-card-text class="mt-2">
                <p>Send a Message to...</p>
                <v-textarea
                  outlined
                  v-model="msg_text"
                  name="input-7-4"
                  label="Outlined textarea"
                  value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                ></v-textarea>
                <div class="text-left mt-5">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn 
                        class="ml-5"
                        color="primary"
                        @click="msg_modal=false"
                      >Send</v-btn>
                    </v-col>
                  </v-row>
                  </div>
              </v-card-text>
            </v-col>
          </v-row>
       
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import ExcelIcon from "@/components/Excel";
import SkeletonRevenue from "@/components/SkeletonRevenue";

export default {
  components: { NoData, SkeletonRevenue,ExcelIcon },
  computed : {
    ...mapGetters(["user"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
  },
  data() {
    return {
      namespace: "Reports",
      page: "BosseBayers",
      UserID:null,
      msg_modal:false,
      msg_text:'',
      loading: true,
      errorid: null,
      search: '',
      customers: null,
      headers: [
          { text: '#', value: 'index' },
          { text: 'UserName', value: 'UserName' },
          { text: 'eBayer', value: 'eBayer' },
          { text: 'eBay MarketPlace', value: 'SiteName' },
          { text: 'Owner', value: 'Name' },
          { text: 'City', value: 'CityName' },
          { text: 'Country', value: 'Country' },
          { text: 'Active', value: 'Authorized' },
          { text: 'Token Expiry', value: 'TokenExpiry' },
          { text: 'FeedbackScore', align: 'end',value: 'FeedbackScore' },
          { text: 'Last Month Turnover', align: 'end', value: 'LastMonthTurnover' },
        ],      
    };
  },
  created(){
    this.loadData()
  },
  methods:
  {
    async toggleActive(email){
      console.log(email);
    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"timeframe":this.timeframe.toString(),"suppliers":this.enabled_SuppliersAccounts.toString()};
      window.location.href='/ajax/reports/cogs_report_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      this.loading=true;
      try
      {
          const res = await this.$http.post('/boss/ebayers.php', {"jwt":jwt});
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payload.table;
              console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
  }
};
</script>